export const LineFinal = () => {
  return (
    <div className="flex justify-start items-center ml-52 -mt-[681px]">
      <div className="flex justify-start items-start w-[58px] flex-wrap rounded">
        <div className="w-[55px] h-[1px] bg-gray-100 mb-[200px]"></div>
        <div className="w-[55px] h-[1px] bg-gray-100 mt-[180px]"></div>
      </div>
      <div className="-mx-[55px] rounded">
        <div className="w-[225px] h-[1px] bg-gray-100 rotate-90 mb-[77px] -mx-[60px] "></div>
        <div className="w-[48px] h-[1px] bg-gray-100 mx-[55px]"></div>
        <div className="w-[225px] h-[1px] bg-gray-100 rotate-90 mt-[77px] -mx-[60px]"></div>
      </div>
    </div>
  );
};
